import * as Interfaces from '../interfaces/menu';

export class Menu implements Interfaces.Menu {
    public constructor(
        apiResponse: any
    ) {
        this.name = apiResponse.viewName;
        this.icon = apiResponse.icon;
        this.url = apiResponse.urlField;
        this.color = apiResponse.color;
        this.id = apiResponse.id;
        this.order=apiResponse.name;
        this.children = [];
    }

    public id: string;
    public order:string;
    public name: string;
    public icon: string;
    public url: string;
    public children: any[];
    public parent: any;
    public color: string;
}


export class EditMenu {
    public constructor(
        apiResponse: any
    ) {
        this.id=apiResponse.id;
        this.order=apiResponse.order;
        this.viewName=apiResponse.viewName;
        this.icon=apiResponse.icon;
        this.urlField=apiResponse.urlField;
        this.endPoint=apiResponse.endPoint;
        this.visible=apiResponse.visible;
        this.color=apiResponse.color;
    }

    public id: string;
    public order:string;
    public viewName: string;
    public icon: string;
    public urlField: string;
    public endPoint: string;
    public parent: string | undefined;
    public visible: boolean;
    public color: string;
    public children: any | undefined;
}

